<template>
  <div id="contenedor-main-contrato-cronograma">
    <v-btn @click="refresacar">Refrescar</v-btn>
    <v-skeleton-loader
      v-if="$apollo.loading"
      type="list-item-three-line, list-item-three-line, list-item-three-line">
    </v-skeleton-loader>
    <v-timeline
      v-if="!$apollo.loading"
      dense
      align-top>
      <template
        v-for="(registro, index) in cronograma">
        <template>
          <v-timeline-item
            :key="index"
            :color="registro.color"
            fill-dot
            :icon="registro.icon">
            <v-row>
              <v-col
                cols="6"
                md="3">
                <v-chip
                  small>
                  <v-icon
                    left
                    small>
                    mdi-calendar
                  </v-icon>
                  <strong>
                    {{ registro.fecha }}
                  </strong>
                </v-chip>
              </v-col>
              <v-col>
                <strong>
                  {{ registro.titulo  }}
                </strong>
                <div class="text-caption">
                  {{ registro.subtitulo }}
                </div>
              </v-col>
            </v-row>
          </v-timeline-item>
        </template>
      </template>
    </v-timeline>
  </div>
</template>

<script>
import CONTRATO_CRONOGRAMA from '@/graphql/querys/administracion/contratos/contrato/cronograma.gql';
import mixContratoFechas from './mixContratoFechas';

export default {
  name: 'MainContratoCronograma',
  mixins: [mixContratoFechas],
  props: {
    idContrato: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      tiposDePago: {
        anticipo: {
          nombre: 'Anticipo',
          color: 'green darken-1',
        },
        estimacion: {
          nombre: 'Estimacion',
          color: 'light-blue darken-1',
        },
        gasto: {
          nombre: 'Gasto',
          color: 'pink darken-1',
        },
        escalatoria: {
          nombre: 'Escalatoria',
          color: 'brown darken-1',
        },
      },
    };
  },
  methods: {
    refresacar() {
      this.$apollo.queries.contrato.refetch({
        idContrato: this.idContrato,
      });
    },
    formatearFecha(fecha) {
      return new Date(`${fecha}T00:00:00`).toLocaleDateString();
    },
    fechaDelContrato(contrato) {
      if (!contrato) return '';
      if (contrato.modificado.fechaInicio) {
        return `Periodo ${this.formatearFecha(contrato.modificado.fechaInicio)} ${this.formatearFecha(contrato.modificado.fechaTermino)} Modificado`;
      }

      return `Periodo ${this.formatearFecha(contrato.fechaInicio)} ${this.formatearFecha(contrato.fechaTermino)}`;
    },
    agregarPagoRegistro(cronograma, registro, tipo) {
      if (!registro.solicitudPago) return;
      if (!registro.solicitudPago.pagosDetalles) return;

      // Registrar pago
      cronograma.push({
        fecha: registro.solicitudPago.pagosDetalles[0].pago.fecha,
        titulo: this.tiposDePago[tipo] ? `Pago ${this.tiposDePago[tipo].nombre}` : '',
        subtitulo: this.$options.filters
          .currency(registro.solicitudPago.pagosDetalles[0].pago.importe),
        color: this.tiposDePago[tipo] ? this.tiposDePago[tipo].color : '',
        icon: 'monetization_on',
      });
    },
  },
  apollo: {
    contrato: {
      query: CONTRATO_CRONOGRAMA,
      variables() {
        return {
          idContrato: this.idContrato,
        };
      },
    },
  },
  computed: {
    cronograma() {
      if (!this.contrato) return [];
      const cronograma = [];
      // Fecha del contrato
      cronograma.push({
        fecha: this.contrato.fecha,
        titulo: 'Contrato',
        subtitulo: this.fechaDelContrato(this.contrato),
        color: 'orange darken-2',
      });

      // Fechas del anticipo
      for (let i = 0; i < this.contrato.anticipos.length; i += 1) {
        // Solicitud de anticipo
        cronograma.push({
          fecha: this.contrato.anticipos[i].fecha,
          titulo: 'Solicitud anticipo',
          subtitulo: '',
          color: 'green darken-1',
        });

        // Pago del anticipo
        this.agregarPagoRegistro(cronograma, this.contrato.anticipos[i], 'anticipo');
      }

      // Estimaciones
      for (let i = 0; i < this.contrato.estimaciones.length; i += 1) {
        // Presentacion de la estimacion
        cronograma.push({
          fecha: this.contrato.estimaciones[i].fechaPresentacion,
          titulo: `Presentación estimacion ${this.contrato.estimaciones[i].numero}`,
          subtitulo: `Periodo ${this.formatearFecha(this.contrato.estimaciones[i].fechaDel)} ${this.formatearFecha(this.contrato.estimaciones[i].fechaAl)} Estimado ${this.$options.filters.currency(this.contrato.estimaciones[i].importeEstimado)}`,
          color: 'light-blue darken-1',
        });

        // Pago estimacion
        this.agregarPagoRegistro(cronograma, this.contrato.estimaciones[i]);
      }

      // Convenios
      for (let i = 0; i < this.contrato.convenios.length; i += 1) {
        // Convenio modificatorio //
        cronograma.push({
          fecha: this.contrato.convenios[i].fecha,
          titulo: `Convenio modificatorio ${this.contrato.convenios[i].tipo}`,
          subtitulo: `${this.contrato.convenios[i].numero}`,
          color: 'light-blue darken-1',
        });
      }

      // Gastos
      for (let i = 0; i < this.contrato.gastos.length; i += 1) {
        // Registro de gasto
        cronograma.push({
          fecha: this.contrato.gastos[i].fechaAl,
          titulo: `Registro del gasto ${this.contrato.gastos[i].numero}`,
          subtitulo: `Monto ${this.$options.filters.currency(this.contrato.gastos[i].total)}`,
          color: 'pink darken-1',
        });

        // Pago del pago
        this.agregarPagoRegistro(cronograma, this.contrato.gastos[i], 'gasto');
      }

      // Escalatorias
      for (let i = 0; i < this.contrato.escalatorias.length; i += 1) {
        // Registro de escalatorias
        cronograma.push({
          fecha: this.contrato.escalatorias[i].fechaAl,
          titulo: `Registro de escalatoria ${this.contrato.escalatorias[i].numero}`,
          subtitulo: `Monto ${this.$options.filters.currency(this.contrato.escalatorias[i].total)}`,
          color: 'brown darken-1',
        });

        // Pago de la escalatoria
        this.agregarPagoRegistro(cronograma, this.contrato.escalatorias[i], 'escalatoria');
      }

      // Fechas del contrato
      for (let i = 0; i < this.contrato.fechas.length; i += 1) {
        cronograma.push({
          fecha: this.contrato.fechas[i].fecha,
          titulo: `${this.listadoDeTipos[this.contrato.fechas[i].tipo]}`,
          subtitulo: '',
          color: 'grey darken-1',
        });
      }

      return cronograma
        .sort((a, b) => new Date(a.fecha) - new Date(b.fecha))
        .map((item) => ({
          ...item,
          fecha: this.formatearFecha(item.fecha),
        }));
    },
  },
};
</script>

<style lang="scss">

</style>
